import { BASE_URL } from "../lib/api";

const src = (url) => (url?.startsWith("/") ? `${BASE_URL}${url}` : url);

export const EndingFramePicker = ({ frames, selected, onSelect, episode }) => {
  const others = frames.filter((f) => f.url !== selected);
  return (
    <div data-testid="ending-frame-picker" className="space-y-2">
      <div className="relative rounded-lg overflow-hidden border border-border/50 bg-black">
        <img data-testid="ending-frame-selected" src={src(selected)} alt="Ending frame" className="w-full h-72 object-contain" />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
          <p className="text-white text-sm font-medium">Episode {episode || 2} starts from this frame</p>
        </div>
      </div>
      {others.length > 0 && (
        <div>
          <p className="text-xs text-muted-foreground mb-1">Doesn't look right? Pick a slightly earlier moment:</p>
          <div className="flex gap-2">
            {others.map((f, i) => (
              <button key={f.url} type="button" data-testid={`ending-frame-option-${i}`} onClick={() => onSelect(f.url)}
                className="relative w-16 h-28 rounded-md overflow-hidden border border-border/50 bg-black hover:border-primary transition-colors">
                <img src={src(f.url)} alt={`${f.seconds_before_end}s before end`} className="w-full h-full object-contain" />
                <span className="absolute bottom-0 right-0 bg-black/70 text-[10px] text-white px-1">-{f.seconds_before_end}s</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
